import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewChecked, ViewChild, Input } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { RequestTools } from '@service/request.tools';
import { Tools } from '@service/tools';
import { Subscription, catchError, forkJoin, from, interval, lastValueFrom, map, of } from 'rxjs';
import {
    currentSelectedBsk,
    truncateString,
    concatAllBasket,
    setArrayAllBasket,
    getInternalPrefUsr,
    findItem} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { Router } from '@angular/router';
import { EditorService } from '@service/editor.service';
import { CommonService } from '@service/common.service';
import { ParamUrlService } from '@service/paramurl.service';
import { BasketService } from '@service/basket.service';
import { WebPushService } from '@service/webpush.service';
import { FilterService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { addInfosBsk, getGauge, getMaxValue, getValueColor, setCurrentSelectedBsk } from '@core/_utils/basket.utils';

@Component({
    selector: 'page-basket-list',
    styleUrls: ['./page-basket-list.component.scss'],
    templateUrl: './page-basket-list.component.html',
})
export class PageBasketListComponent implements OnInit, OnDestroy, AfterViewChecked {
    @Input() public accesBsk: boolean = false;
    @Input() public accesShortBsk: boolean = false;
    public basketMailList: any[];
    public basketCollectList: any[];
    public basketPublishList: any[];
    public basketActionList: any[];
    public basketInputList: any[];
    public basketOutputList: any[];
    public basketSystemList: any[];

    public basketMailListGrp: any[];
    public basketCollectListGrp: any[];
    public basketPublishListGrp: any[];
    public basketActionListGrp: any[];
    public basketInputListGrp: any[];
    public basketOutputListGrp: any[];
    public basketSystemListGrp: any[];

    public basketAll: any[];
    public VariableList: any[];
    public title: string;
    private bskListCount: any[];
    public index: number;
    public displayFilter: boolean = false;
    public displaySearch: boolean = false;
    public displayNewDoc: boolean = false;
    public error = false;
    public titleRequest: string = '';

    @ViewChild('dv') public dv: DataView;

    public execTimer: any;
    public timerSubcribe: Subscription;
    public currentSelectedBsk: currentSelectedBsk;
    public currentfilterName: string = '';
    public basketAllWrk: any[];
    public base: boolean = true;
    public source: string;
    public target: string;
    public divSrc: any;
    public blockAddFile: boolean = false;
    public reorgBsk: boolean = false;
    public internalPrefUsr: any;
    public tagList: any[];
    public tagGroup: any[];
    public tagListSelect: any[];
    public tagListGroup: any[];
    public filterName: string = '';
    public allowFullText: boolean = false;
    private closest: string = '';
    public bsk: currentSelectedBsk;    
    public baseRoot = '';
    public storagePath = '';
    public priority = '5';
    public usePreProcess = false;
    public preProcessName = '';
    public parameterList = [];

    constructor(
        private cdRef: ChangeDetectorRef,
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private requestTools: RequestTools,
        private router: Router,
        private tools: Tools,
        public menu: MenuServiceInt,
        public editorService: EditorService,
        private commonService: CommonService,
        private paramUrlService: ParamUrlService,
        public basketService: BasketService,
        private filterService: FilterService,
        private translate: TranslateService,
        private webPushService: WebPushService
    ) {
        this.menu.display = true;
        let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
        this.internalPrefUsr = getInternalPrefUsr();        
        this.basketAll = new Array();
        this.basketAllWrk = new Array();
        this.accesBsk = false;
        this.basketService.delay = wInternal.internalcfg;        
        this.titleRequest = this.translate.instant('Query_List_1');        
    }

    public ngOnInit() {
        this.tagGroup = [];
        return from(this.menu.getMenu()).pipe(
            map(result => {
                this.allowFullText = this.menu.allowFullText;
                this.timerSubcribe = null;
                this.index = 0;
                this.getBasketList(true);
                this.execTimer = interval(10000);
                this.commonService.checkReset();
                this.reorgBsk = false;        
                this.setFilter();
                this.closest = this.getClosest();
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            })).subscribe();
    }

    public ngOnDestroy() {
        if (this.timerSubcribe !== null && this.timerSubcribe !== undefined) {
            this.timerSubcribe.unsubscribe();
        }
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    private timerExecSubcribe() {
        this.timerSubcribe = this.execTimer.subscribe(
            (data) => this.timerExecute(data),
            (error) => this.errorTimer(error)
        );
    }

    private errorTimer(aError) {
        console.log('PageBasketListComponent errorTimer', aError);
    }

    private async timerExecute(aData) {
        let wRes: any = {};
        let wMess = '';
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getbskcount', ''));
            this.bskListCount = wRes;
            wMess = this.updateCounter();
            if (wMess !== '') {
                this._messageService.addInfo(this.translate.instant('New_DocBsk') + '\n' + wMess);
                this.webPushService.showNotification('Documalis', {body: this.translate.instant('New_DocBsk') + '\n' + wMess});
                this.execFilter(this.filterName, this.tagListSelect);
            }
        } catch (error) {
            console.log('PageBasketListComponent timerExecute error', error);
            this.timerSubcribe.unsubscribe();
            if (error.status === 401) {
                this.router.navigate(['expired']);
            } else {
                this.router.navigate(['page-error']);
            }
        }
    }

    private updateCounter() {
        let wMess = '';
        wMess = wMess + this.updateCounterDetail(this.basketMailList);
        wMess = wMess + this.updateCounterDetail(this.basketCollectList);
        wMess = wMess + this.updateCounterDetail(this.basketPublishList);
        wMess = wMess + this.updateCounterDetail(this.basketActionList);
        wMess = wMess + this.updateCounterDetail(this.basketInputList);
        wMess = wMess + this.updateCounterDetail(this.basketOutputList);
        wMess = wMess + this.updateCounterDetail(this.basketSystemList);
        wMess = truncateString(wMess);
        return wMess;
    }

    private updateCounterDetail(aData) {
        let wMess = '';
        aData.forEach((item) => {
            if (parseInt(item.Information.docCount, 10) < parseInt(this.bskListCount[item.Information.Name], 10)) {
                wMess = wMess + item.Information.Label + ', ';
            }
            if (this.bskListCount[item.Information.Name] !== undefined) {
                item.Information.docCount = this.bskListCount[item.Information.Name];
            }
            if (item.Information.docCount === item.Information.Gradient) {
                item.Information.gauge = 100;
            } else {
                item.Information.gauge = getGauge(
                    Math.ceil((item.Information.docCount / item.Information.Gradient) * 9)
                );
            }
            item.Information.progressColor = getValueColor(item.Information.docCount, item.Information.Gradient);
            item.Information.maxValue = getMaxValue(item.Information.docCount, item.Information.Gradient);
        });
        return wMess;
    }

    private readBasketList() {
        const wParams = { bskname: '', filterAuto: 1 };
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('getuserbskfilters', wParams),
            this.api.execUrlAction('getmenubaskets', ''),
        ]).pipe(
            map(([getCustomEditorlist, getUserBskFilters, getCustmenuBaseList]) => {
                return {getCustomEditorlist, getUserBskFilters, getCustmenuBaseList};
            })
        );
    }

    private async getBasketList(aTimer) {
        let wRes: any = {};
        let wResBsk: any = {};
        let wTranfert: any;
        let wUserBskFilter: any = {};
        let wListTag = [];
        this.tagList = [];        
        this.tagGroup = [];
        this.tagListGroup = [];
        this.title = this.translate.instant('Bsk_List');
        this.init();
        try {
            wResBsk = await lastValueFrom(this.readBasketList());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.editorService.setCustomEditorList(wResBsk.getCustomEditorlist.CustomEditorList);
        wUserBskFilter.data = wResBsk.getUserBskFilters.data;
        try {
            wRes.data = await lastValueFrom(this.requestTools.getBasketListCount('*'));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        } 
        let wBskTransList = this.requestTools.getBskTransList(wRes.data.getBasketList);
        wTranfert = this.tools.getBasketTransfert(wBskTransList, wRes.data.getbskListCount, 
            false, wRes.data.getTagBaskets.data, wUserBskFilter.data, wResBsk.getCustmenuBaseList.data);

        this.basketMailList = wTranfert.wBasketMailList;
        this.basketCollectList = wTranfert.wBasketCollectList;
        this.basketPublishList = wTranfert.wBasketPublishList;
        this.basketActionList = wTranfert.wBasketActionList;
        this.basketInputList = wTranfert.wBasketInputList;
        this.basketOutputList = wTranfert.wBasketOutputList;
        this.basketSystemList = wTranfert.wBasketSystemList;

        wListTag = JSON.parse(localStorage.getItem('listtagbsk'));
        wBskTransList = this.requestTools.getBskTransList(wRes.data.getBasketList, 'group');
        wTranfert = this.tools.getBasketTransfert(wBskTransList, wRes.data.getbskListCount, 
            false, wListTag, wUserBskFilter.data, wResBsk.getCustmenuBaseList.data);

        this.basketMailListGrp = wTranfert.wBasketMailList;
        this.basketCollectListGrp = wTranfert.wBasketCollectList;
        this.basketPublishListGrp = wTranfert.wBasketPublishList;
        this.basketActionListGrp = wTranfert.wBasketActionList;
        this.basketInputListGrp = wTranfert.wBasketInputList;
        this.basketOutputListGrp = wTranfert.wBasketOutputList;
        this.basketSystemListGrp = wTranfert.wBasketSystemList;

        this.bskListCount = wRes.data.getbskListCount;

        // Ajout des bannettes utilisateurs défini par l'association (surcharge)
        this.addUserBasket(wRes.data.getBasketList.BasketMailListuser.BasketMail, 'btMail', this.basketMailList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketCollectListuser.BasketCollect, 'btCollect', this.basketCollectList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketActionListuser.BasketAction, 'btAction', this.basketActionList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketInputListuser.BasketInput, 'btInput', this.basketInputList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketOutputListuser.BasketOutput, 'btOutput', this.basketOutputList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketPublishListuser.BasketPublish, 'btPublish', this.basketPublishList, wRes.data.getbskListCount);
        this.addUserBasket(wRes.data.getBasketList.BasketSystemListuser.BasketSystem, 'btSystem', this.basketSystemList, wRes.data.getbskListCount);

        this.basketAll = concatAllBasket(
            this.basketMailList,
            this.basketCollectList,
            this.basketPublishList,
            this.basketActionList,
            this.basketInputList,
            this.basketOutputList,
            this.basketSystemList
        );

        /**
         * trie par libéllé
         */

        this.sortBasket(this.basketAll)

        if (this.accesShortBsk === true) {
            this.basketAll = this.filterBasket();
        }
        if (wRes.data.getTagBase.data.length !== 0)  {
            this.tagList = this.setTagList(wRes.data.getTagBase.data);
        }
       
        wListTag = JSON.parse(localStorage.getItem('taglistgroup'));
        if (wListTag !== null) {
            this.tagGroup = this.setTagList(wListTag);
        }

        if (wRes.data.getUserBskPos.data.length === 0 || wRes.data.getUserBskPos.data[0]?.bsklist === '') {
            this.setBasketAllWrk();
        } else {
            this.setBasketPos(wRes.data.getUserBskPos.data);
        }                
        this.execReOrder();
        this.onChangeCkEmptyBsk();
        if (aTimer === true && this.accesBsk === false) {
            this.timerExecSubcribe();
        }
        if (this.paramUrlService.basketName !== '') {
            this.menu.updateRestrited(this.paramUrlService.restricted);
            this.execAuto();
        }

    }

    private addUserBasket(aBskList, abskType, aDestBskList, aInfo) {
        let wRes = -1;
        aBskList.forEach((item, index) => {
            wRes = this.bskPresent(item.Information.Name, aDestBskList);
            if (wRes === -1) {
                aBskList = addInfosBsk(aBskList, abskType, aInfo, [], this.api, [], true, []);
                aDestBskList.push(aBskList[index]);
            }
        });
    }

    private bskPresent(aName, aDestBskList) {
        let wRes = -1;
        for (let i = 0; i < aDestBskList.length; i++) {
            if ( aDestBskList[i].Information.Name === aName) {
                wRes = i;
                break;
            }
        }
        return wRes;
    }

    public onChangeCkEmptyBsk() {
        if (this.tagListGroup.length !== 0) {            
            this.tagListGroup = [];
            this.switchMode(false);
        }
        if (this.internalPrefUsr.emptyBsk === true) {
            this.basketAll = this.filterBasket();
        } else {
            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );
            this.sortBasket(this.basketAll)
            this.execReOrder();
            this.execSubFilter(this.filterName, this.tagListSelect);
        }
    }
    
    public filter(aValue) {
        this.execFilter(aValue, this.tagListSelect);
    }

    public filterTag($event) {
        this.execFilter($event.value, this.tagListSelect);
    }

    public filterGroup($event) {
        if ($event.length === 0) {
            this.switchMode(false);
        } else {            
            this.execFilter($event.value, this.tagListGroup, true);
        }
    }

    private execFilter(aValue, aTag, aGrp = false) {
        this.switchMode(aGrp);
        if (aGrp === true) {
            this.execSubFilter(aValue, aTag);
            return;
        }
        this.execReOrder();
        this.onChangeCkEmptyBsk();
        this.execSubFilter(aValue, aTag);
    }

    private switchMode (aGrp) {
        if (aGrp === true) {
            this.basketAll = concatAllBasket(
                this.basketMailListGrp,
                this.basketCollectListGrp,
                this.basketPublishListGrp,
                this.basketActionListGrp,
                this.basketInputListGrp,
                this.basketOutputListGrp,
                this.basketSystemListGrp
            );              
        } else {
            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );           
        }
    }

    private execSubFilter(aValue, aTag) {
        this.basketAll = this.filterService.filter(this.basketAll, ['Information.Label'] , aValue, 'contains');
        this.basketAll = this.filterService.filter(this.basketAll, ['tag'] , aTag, 'custom-find');        
    }

    private setFilter() {
        const customFilterName = 'custom-find';    
        this.filterService.register(customFilterName, (value, filter): boolean => {
            if (filter === undefined || filter === null || filter.length === 0) {
                return true;
            }    
            if (value === undefined || value === null) {
                return false;
            }
            for (let item of filter) {
                if (value.indexOf(item.code) !== -1) {
                    return true;
                }
            }
            return false;
        });
    }

    private setTagList(aList) {       
        let wArray = [];
        for (let i = 0; i < aList.length; i++) {
            wArray.push({name: aList[i].label ,code: aList[i].name});
        }
        return wArray;
    }

    private filterBasket() {
        if (this.accesShortBsk === true) {
            return this.basketAll.filter((item) => {
                if (item.Information.docCount !== 0) {
                    return item;
                }
            });
        } else {
            return this.basketAll.filter((item) => {
                if (item.Information.docCount !== 0 || item.UserBasket.DragDrop === 'true') {
                    return item;
                }
            });            
        }
    }

    private execEmptyBsk(aEmptyBsk) {
        if (aEmptyBsk === true) {
            this.basketAll = this.filterBasket();
        } else {
            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );
            this.setBasketAllWrk();
        } 
    }

    public onReorgBsk() {
        if (this.reorgBsk === true) {           
            this.tagListSelect = [];
            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );
            this.sortBasket(this.basketAll)
            this.execReOrder();
            this.blockAddFile = true;
        } else {
            this.blockAddFile = false;
            this.execReOrder();
            if (this.internalPrefUsr.emptyBsk === true) {
                this.execEmptyBsk(this.internalPrefUsr.emptyBsk);
            }
        }
    }

    private execReOrder() {
        let wIndex = -1;
        for (let i = 0; i < this.basketAll.length; i++) {
            if ( this.basketAll[i].Information.Name !== this.basketAllWrk[i]) {
                wIndex = this.getIndex(this.basketAll, this.basketAllWrk[i]);
                if (wIndex !== -1) {
                    const tmp = this.basketAll[i];
                    this.basketAll[i] = this.basketAll[wIndex];
                    this.basketAll[wIndex] = tmp;
                }
            }
        }
    }

    // Initialisation du tableau de travail
    private setBasketAllWrk() {
        this.basketAllWrk = [];
        this.basketAll.forEach((item) => {
            this.basketAllWrk.push(item.Information.Name);
        });

    }

    private setBasketPos(aData) {
        this.basketAllWrk = [];
        let wList = [];    
        if (aData[0].bsklist !== undefined) {
            wList = aData[0].bsklist.split(',');
            setArrayAllBasket(this.basketAllWrk, wList);
        } else {
            this.setBasketAllWrk();
        }
    }

    private getIndex(aBskList, aName) {
        let wIndex = -1;
        wIndex = aBskList.findIndex((item) => {
            return item.Information.Name === aName;
        });
        return wIndex;
    }

    public saveBsk($event) {            
        this.basketAllWrk = [];
        if ($event === true) {
            this.setBasketAllWrk();
        }
        this.onSaveBskPos($event);
    }

    public async onSaveBskPos(aSave) {
        const wData = { bsklist: this.basketAllWrk.join() };
        try {
            await lastValueFrom(this.api.execUrlAction('setuserbskpos', wData));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.blockAddFile = false;
        this.reorgBsk = false;
        if (aSave === false) {
            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );
        }
        this.sortBasket(this.basketAll)
        this.execReOrder();
        if (this.internalPrefUsr.emptyBsk === true) {
            this.execEmptyBsk(this.internalPrefUsr.emptyBsk);
        }      
    }

    public allowDrop(ev) {
        ev.preventDefault();
    }        

    public dragEnter(ev) {
        if (ev.currentTarget !== this.divSrc) {
            this.verifyBorder(ev);
        }
    }

    public drag(ev) {
        this.divSrc = ev.currentTarget;
        let img = new Image();
        img.src = this.divSrc.querySelector('.img-hover').src;
        ev.dataTransfer.setDragImage(img, 0, 0);
        this.divSrc.style.opacity = '0.4';
        this.base = true;
    }
    
    public dragOver(ev) {
        this.verifyBorder(ev);
    }
    
    public dragLeave (ev){
        this.setBorder(ev, 'none');
    }

    private verifyBorder(ev) {
        if (ev.target.closest(this.closest) !== null) {            
            if (ev.target.closest(this.closest).style.border != "2px dotted black") {
                this.setBorder(ev, '2px dotted black');
            }
        }
    }

    private setBorder(ev, aValue) {
        if (ev.target.closest(this.closest) !== null) {         
            ev.target.closest(this.closest).style.border = aValue;
        }
    }

    public onCompactMode() {
        this.closest = this.getClosest();        
    }

    private getClosest() {
        if (this.internalPrefUsr.bskCompact === true) {
            return ".basket-compact";
        } else {
            return ".basket";
        }
    }

     public drop(ev) {
        let wSrc = -1;
        let wTrg = -1;
        ev.preventDefault();
        this.source = '';
        this.target = '';
        if (this.base === false) {
            return;
        }
        if (ev.currentTarget === this.divSrc) {
            // déplacement de la div sur sa position
            this.base = false;
        } else {       
            this.base = false;
            this.source = this.divSrc.id;
            this.target = ev.currentTarget.id;
        }
        wSrc = this.basketAll.findIndex((item) => {
            return item.Information.Name === this.source;
        });
        wTrg = this.basketAll.findIndex((item) => {
            return item.Information.Name === this.target;
        });
        if (wSrc !== -1 && wTrg !== -1) {
            this.basketAll = this.decale(wSrc, wTrg);
        }
        this.divSrc.style.opacity = 'unset';
        this.dragLeave(ev);
    }

    private decale(i,j){
        //décale l'élément index i à l'index j
        //résultat: nouvel Array, Array original non modifié
        // on préserve le ième élément
        let wTmp=this.basketAll[i];
        // b Array sans le iéme de a
        let wTmpArr=[].concat(this.basketAll.slice(0,i),this.basketAll.slice(i+1));
        // retour Array avec ième élément décalé à position j
        return [].concat(wTmpArr.slice(0,j),wTmp,wTmpArr.slice(j));
    }
    
    public refresh() {
        this.getBasketList(false);
    }

    private execAuto() {
        let wIndex = -1;
        wIndex = this.findBasket(this.basketAll, this.paramUrlService.basketName);
        if (wIndex !== -1) {
            this.onSelectBasket(null, this.basketAll[wIndex]);
        }
        this.paramUrlService.clear();
    }

    private findBasket(aList, aName) {
        let wIndex = -1;
        wIndex = aList.findIndex((item) => {
            return item.Information.Name === aName;
        });
        return wIndex;
    }

    // Click sur l'icone de filtrage des bannettes pour recherche plein texte
    public onFilterBasketSearch($event, bsk) {
        this.displaySearch = true;
        this.currentSelectedBsk = setCurrentSelectedBsk(bsk, null);
    }

    public closeSearch() {
        this.displaySearch = false;
    }
    
    public onClickSearch($event) {
        this.displaySearch = false;        
        this.VariableList = [];
        this.execSelectBasketLst(this.VariableList, false, [], false, true, $event.searchText, false);
    }

    // Click sur l'icone de filtrage des bannettes
    public async onFilterBasket($event, bsk) {
        let wRes: any;
        this.displayFilter = true;
        this.currentSelectedBsk = setCurrentSelectedBsk(bsk, null);
        wRes = await this.basketService.verifyUserFilter(this.currentSelectedBsk.bskName, this.currentSelectedBsk.bskTypeSearch);
        if (wRes === false) {
            this.displayFilter = false;
        }
    }

    public onClickFilter(event) {
        this.displayFilter = false;
        if (
            event.variableListRequest !== null &&
            event.variableListRequest !== undefined &&
            event.variableListRequest.length > 0
        ) {
            this.basketService.currentIdReqentete = this.requestTools.getIdRequest(event.variableListRequest);
            this.execSelectBasketLst(
                event.variableListRequest,
                true,
                event.variableListRequest,
                event.filterAuto,
                event.emptyField,
                '',
                event.filterActiv
            );
        } else {
            this.VariableList = [];
            this.execSelectBasketLst(this.VariableList, !event.filterAuto, [], false, true,'',event.filterActiv);
        }
    }

    public onCloseFilter() {
        this.displayFilter = false;
    }

    public onAddDocBasket($event, bsk) {
        this.bsk = setCurrentSelectedBsk(bsk, this.api);
        this.baseRoot = '';
        this.storagePath = '';
        this.priority = '5';
        this.usePreProcess = false;
        this.preProcessName = '';
        this.parameterList = [];

        if (bsk.BaseRoot) {
            if (!Array.isArray(bsk.BaseRoot.Name)) {
                this.baseRoot = bsk.BaseRoot.Name;
            }
            if (!Array.isArray(bsk.BaseRoot.Path)) {
                this.storagePath = bsk.BaseRoot.Path;
            }
            if (!Array.isArray(bsk.BaseRoot.Priority)) {
                this.priority = bsk.BaseRoot.Priority;
            }
        }
        this.usePreProcess = this.bsk.bskUsePreProcess;
        this.preProcessName = this.bsk.bskPreProcessName;
        this.parameterList = this.bsk.bskParameterList;

        this.displayNewDoc = true;
    }

    public onCloseNewDoc() {
        this.displayNewDoc = false;
    }

    public onSelectBasket($event, bsk) {
        if (!this.verifyCount(bsk)) {
            return;
        }
        this.basketService.currentFilterId = 0;
        this.basketService.currentIdReqentete = -1;
        this.basketService.currentFilterAuto = false;
        this.currentSelectedBsk = setCurrentSelectedBsk(bsk, this.api);
        this.verifyUserFilter(this.currentSelectedBsk);
    }

    private async verifyUserFilter(bsk) {
        this.displayFilter = false;
        await this.basketService.verifyUserFilter(bsk.bskName, bsk.bskTypeSearch);
        if (this.basketService.getFilterList === true) {
            await this.selectBasket();
        }
    }

    private async selectBasket() {
        let wListRequest: any;
        let wIndex = -1;
        let wVariableList: any[];
        this.currentfilterName = '';
        this.VariableList = [];
        wVariableList = null;
        if (this.basketService.currentFilterAuto === true) {
            wListRequest = await this.requestTools.getRequestListBasket(
                'getrequestsbyuser',
                this.basketService.currentIdReqentete,
                this.basketService.currentFilterParam,
                ''
            );
            wIndex = findItem(wListRequest.requestList, this.basketService.currentIdReqentete, 'id');
            if (wIndex !== -1) {
                this.currentfilterName = wListRequest.requestList[wIndex].label;
                wVariableList = wListRequest.requestList[wIndex].webReqDetails;
                this.editorService.updateVariable(wVariableList);
                await this.execSelectBasketLst(wVariableList,false,[], this.basketService.currentFilterAuto,
                    wListRequest.requestList[wIndex].emptyfield,'',true
                );
            } else {
                await this.execSelectBasketLst(this.VariableList, false, [], false, true, '', false);
            }
        } else {
            await this.execSelectBasketLst(this.VariableList, false, [], false, true, '', false);
        }
    }

    private async execSelectBasketLst(aVariableList, aUpdateFilter, aVariableFilter, aCurrentFilterAuto, aEmptyField, aSearchWord, aFilterActiv) {
        let wRes: any;        
        if (aVariableList !== null) {
            this.VariableList = this.editorService.upateListVariable(aVariableList);
        }
        this.api.bskVariable = [...this.VariableList];
        this.api.bskCurrentSelectedBsk = JSON.parse(JSON.stringify(this.currentSelectedBsk));
        this.api.bskListCount = JSON.parse(JSON.stringify(this.bskListCount));
        if (aFilterActiv === false) {
            this.currentfilterName = '';
        } else {
            this.getFilterName();
        }
        this.api.currentfilterName = this.currentfilterName;
        if (this.currentfilterName !== '') {
            this.basketService.useFilter = true;
        } else {
            this.basketService.useFilter = false;            
        }        
        this.basketService.initialize(this.currentSelectedBsk, this.bskListCount);
        wRes = await this.basketService.execSelectBasket(
            this.VariableList,
            aUpdateFilter,
            aVariableFilter,
            aCurrentFilterAuto,
            aEmptyField,
            aSearchWord
        );
        if (wRes.success === true) {
            this.api.bskDocList = JSON.parse(JSON.stringify(wRes));
            this.api.searchWord = aSearchWord;
            let wUrl = this.router.url;            
            if (wUrl.substring(0, 19) !== '/page-basket-detail') {
                this.router.navigate(['/page-basket-detail']);
            } else {
                this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                    this.paramUrlService.basketName = this.currentSelectedBsk.bskName;
                    this.router.navigate(['/page-basket-detailbis']);
                });
            }
        }
    }

    private getFilterName() {
        this.basketService.findFilterName();
        if (this.basketService.filterNameOk === true) {
            this.currentfilterName = this.basketService.currentfilterName;
        }
    }

    private verifyCount(bsk) {
        if (bsk.Information.docCount === 0) {
            this._messageService.addErrorNoStick(this.translate.instant('Bsk_Empty'));
            return false;
        } else {
            return true;
        }
    }

    private init() {
        this.basketMailList = null;
        this.basketCollectList = null;
        this.basketPublishList = null;
        this.basketActionList = null;
        this.basketInputList = null;
        this.basketOutputList = null;
        this.basketSystemList = null;
        this.bskListCount = null;
        this.basketMailListGrp = null;
        this.basketCollectListGrp = null;
        this.basketPublishListGrp = null;
        this.basketActionListGrp = null;
        this.basketInputListGrp = null;
        this.basketOutputListGrp = null;
        this.basketSystemListGrp = null;
    }

    public handleChange($event) {}


    private sortBasket(basket){
        basket.sort((a, b) => {
            let labelA = a.Information.Label.toUpperCase(); // Ignorez la casse lors de la comparaison
            let labelB = b.Information.Label.toUpperCase(); // Ignorez la casse lors de la comparaison

            if(labelA < labelB) {
                return -1;
            }

            if(labelA > labelB) {
                return 1;
            }

            // Les labels sont égaux
            return 0;
        });
    }
}
